import React, { useCallback, useMemo, useRef } from "react";
import { useState, useEffect } from "react";
import styles from "./HealthcareReviewPage.module.css";
import { CpnwContainer } from "hooks/useCpnw";
import { HeaderSection, LinkItem, Loading } from "@cpnw/ui";
import RequirementTable from "components/RequirementTable";
import { AdminContainer } from "hooks/useAdmin";
import { format, parseISO } from "date-fns";
import { StaticRoutes } from "pages/routes";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import PassportAdminHealthcareReviewTable from "components/PassportAdminHealthcareReviewTable";
import PassportRequirementSubmissionsHealthcare from "components/PassportRequirementSubmissionsHealthcare";
import { RequirementContainer } from "hooks/useRequirement";
import { AccountContainer } from "hooks/useAccount";

export default function HealthcareReviewPage() {
  const history = useHistory();
  const location = useLocation();
  const {
    contactsToReviewData,
    refetchContactsToReviewData,
    postVerificationComplete,
  } = RequirementContainer.useContainer();

  const { userRoles } = AccountContainer.useContainer();
  

  // API Call on mount
  useEffect(async () => {
    setIsLoading(true);
    await refetchContactsToReviewData();
    setIsLoading(false);
  }, []);

  const data = useMemo(() => {
    if (contactsToReviewData && contactsToReviewData.data.length > 0) {

      const reviews = contactsToReviewData.data.flatMap((a, i) => {
        return {
          id: a.ContactId,
          name: `${a.NameLast}, ${a.NameFirst}`,
          sid: a.IndividualId || "",
          school: a.Facility,
          program: a.Program,
          status: a.RegistrationStatus,
          reviewStatus: a.reviewStatus ? "Needs Review" : null,
          VerificationComplete: a.VerificationComplete,
          VerifiedByType: a.VerifiedByType,
        };
      });
      console.log(reviews);
      const needsReviewAccounts = reviews.filter(reviews => reviews.reviewStatus === "Needs Review");
      const blankStatusAccounts = reviews.filter(reviews => reviews.reviewStatus === null);

      needsReviewAccounts.sort((a, b) => a.name.localeCompare(b.name));
      blankStatusAccounts.sort((a, b) => a.name.localeCompare(b.name));

      const sortedAccounts = [...needsReviewAccounts, ...blankStatusAccounts];

      return sortedAccounts;
    }
    return [];
  }, [contactsToReviewData]);

  const [submissionModalOpen, setSubmissionModalOpen] = useState(false);
  const [submissionModalData, setSubmissionModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const roles = userRoles.map((a) => a.toUpperCase());

  const onItemView = useCallback(
    (item) => {
      //console.log("onItemView", item);
      const student = contactsToReviewData.data.find(
        (a) => a.ContactId == item.id
      );
      const modalData = {
        contactId: student.ContactId,
        studentInfo: {
          lastName: student.NameLast,
          firstName: student.NameFirst,
          school: student.Facility,
          program: student.Program,
          sidEid: student.IndividualId || "",
          email: student.Email,
          phone: student.PrimaryPhone,
          eContact: student.EmergencyContact,
          eContactPhone: student.EmergencyPhone,
        },
        studentPhoto: {
          image: student.PhotoUrl,
          downloadFileName: student.PhotoUrl
        },
        assignmentsInfo: student.Assignments.flatMap((a) => ({
          location: a.Facility,
          startDate: a.StartDate,
          endDate: a.EndDate,
          status: a.Status
        })),
        recordInfo: [],
      };

      setSubmissionModalData(modalData);
      setSubmissionModalOpen(true);
    },
    [contactsToReviewData]
  );

  const autoOpenRef = useRef(false);

  useEffect(() => {
    if (!data.length || autoOpenRef.current) return;
    const contactId = new URLSearchParams(location.search).get('contactId');
    if (!contactId) return;
    const item = data.find(d => String(d.id) === contactId);
    if (item) {
      autoOpenRef.current = true;
      onItemView(item);
    }
  }, [data]);

  return (
    <div className={styles.container}>
      {submissionModalOpen && (
        <PassportRequirementSubmissionsHealthcare
          modalIsOpen={true}
          onModalClose={() => {
            setSubmissionModalData(null);
            setSubmissionModalOpen(false);
          }}
          canCompleteVerification={roles.includes("EDUCATION") || roles.includes("FACULTY") || roles.includes("CPNW-REVIEWER")}
          onCompleteVerification={() => {
            postVerificationComplete(submissionModalData.contactId).then(() => {
              refetchContactsToReviewData();
            });
          }}
          assignmentsInfo={submissionModalData.assignmentsInfo}
          recordInfo={submissionModalData.recordInfo}
          studentInfo={submissionModalData.studentInfo}
          studentPhoto={submissionModalData.studentPhoto}
          contactId={submissionModalData.contactId}
        />
      )}
      <PassportAdminHealthcareReviewTable items={data} onItemView={onItemView} />
      {isLoading && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}
    </div>
  );
}
